export default __webpack_public_path__ + "static/media/appbar-logo.149ae5e6.png";